<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<div class="col-md-12 form-group-inline mb-4">
						<label class="col-form-label label-md col-md-3">Tanggal Pemilahan</label>
						<div class="col-md-3">
							{{models.tglProses | formatDate}}
						</div>
					</div>

					<div class="col-md-12 form-group-inline align-items-start">
						<label class="col-form-label label-md col-md-3">Sumber Pemilahan</label>
						<div class="col-md-9">
							<b-form-group>
								{{ models.stsEwasate }}
							</b-form-group>
							<b-form-group v-if="models.fasilitasSumber" label="Kota">
								{{ models.fasilitasSumber.kota ? models.fasilitasSumber.kota.namaKota : ""  }}
							</b-form-group>
							<b-form-group v-if="models.fasilitasSumber" label="Kecamatan">
								{{ models.fasilitasSumber.kecamatan ? models.fasilitasSumber.kecamatan.namaKecamatan : "" }}
							</b-form-group>
							<b-form-group v-if="models.fasilitasSumber" label="Kelurahan">
								{{ models.fasilitasSumber.kelurahan ? models.fasilitasSumber.kelurahan.namaKelurahan : "" }}
							</b-form-group>
							<b-form-group v-if="models.stsEwasate == '1'" label="Alamat Pickup">
								{{ models.alamatPickup }}
							</b-form-group>
							<b-form-group label="Status OPD">
								{{  models.stsOpd == "1" ? "Pemerintah(OPD)" : "Non OPD" }}
							</b-form-group>
							<b-form-group label="Jenis Fasilitas">
								<div class="col-sm-12 no-padding">
									{{ getJenisFasilitasById(models.jnsFasilitasSumber) }}
								</div>
							</b-form-group>
							<b-form-group label="Fasilitas B3">
								<template v-if="models.fasilitasSumber">
									{{  models.fasilitasSumber.namaFasilitas }}
								</template>
							</b-form-group>
							<b-form-group label="Alamat Fasilitas B3">
								{{ models.fasilitasSumber ? models.fasilitasSumber.alamatFasilitas : "" }}
							</b-form-group>
						</div>
					</div>
					<div class="col-md-12 form-group-inline align-items-start">
						<label class="col-form-label label-md col-md-3">Jenis Sampah B3(Kg)</label>
						<div class="col-md-9">
							<b-form-group class="col-md-6" label="Sisa Produk Mengandung B3">
								{{ models.sisaProdukMengandungB3 }} Kg
							</b-form-group>
							<template>
								<p class="col-form-label fs-15px">Sampah Elektronik e-Waste</p>
								<b-row class="ml-1">
									<b-form-group class="col-md-6" label="Peralatan Pendingin Makanan & Penyejuk Udara">
										{{  models.sampahEwastePendingin }} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Berukuran Besar">
										{{ models.sampahEwasteBesar }} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Berukuran Kecil">
										{{ models.sampahEwasteKecil}} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Komunikasi, Teknologi Informasi dan Layar Monitor">
										{{ models.sampahEwasteKomunikasiTi }} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Pencahayaan">
										{{  models.sampahEwastePencahayaan }} Kg
									</b-form-group>
								</b-row>
							</template>

							<template v-if="models.stsEwasate == '2'">
								<p class="col-form-label fs-15px">Sampah Kemasan B3</p>
								<b-row class="ml-1">
									<b-form-group class="col-md-6" label="Kemasan Kaleng">
										{{models.sampahKemasanKaleng}} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Kemasan Plastik">
										{{ models.sampahKemasanPlastik }} Kg
									</b-form-group>
								</b-row>
								<p class="col-form-label fs-15px">Sampah Lainnya</p>
								<b-row class="ml-1">
									<b-form-group class="col-md-6" label="Sampah Medis">
										{{ models.sampahMedis }} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Battery Aki Bekas">
										{{ models.batteryAkiBekas }} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Kain Majun Terkontaminasi B3">
										{{  models.kainMajunTerkontaminasiB3 }} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Oli Bekas">
										{{  models.oliBekas }} Kg
									</b-form-group>
								</b-row>

							</template>
						</div>
					</div>
					<div class="col-md-12 form-group-inline align-items-start">
						<label class="col-form-label label-md col-md-3">Tujuan Lokasi Penyimpanan (Skala Kota / Kecamatan)</label>
						<div class="col-md-9">
							<b-form-group label="Wilayah">
								{{ models.skala }}
							</b-form-group>
							<b-form-group v-if="models.fasilitasTujuan" label="Kota">
								{{ models.fasilitasTujuan.kota ? models.fasilitasTujuan.kota.namaKota : ""  }}
							</b-form-group>
							<b-form-group v-if="models.fasilitasTujuan && models.skala == 'kecamatan'" label="Kecamatan">
								{{ models.fasilitasTujuan.kecamatan ? models.fasilitasTujuan.kecamatan.namaKecamatan : ""  }}
							</b-form-group>
							<b-form-group label="Jenis Fasilitas">
								{{  getJenisFasilitasById(models.jnsFasilitasTujuan) }}
							</b-form-group>
							<b-form-group label="Fasilitas B3 Tujuan">
								<template v-if="models.fasilitasTujuan">
									{{  models.fasilitasTujuan.namaFasilitas }}
								</template>
							</b-form-group>
							<b-form-group label="Alamat Fasilitas B3">
								{{ models.fasilitasTujuan ? models.fasilitasTujuan.alamatFasilitas : "" }}
							</b-form-group>
						</div>
					</div>
                    <div class="col-md-12 form-group-inline">
						<label class="col-form-label label-md col-md-3">Status Verifikasi</label>
						<div class="col-md-9">
							<span :class="'badge badge-' + getB3StatusClass(models.isVerified)">{{ getB3Status(models.isVerified) }}</span>
						</div>
					</div>
				</b-row>
				<template #footer>
					<template v-if="(models.isVerified == null || models.isVerified == 0) && config.roleUser == 'Dinas'">
                       <b-button type="button" variant="danger" @click="updateStatusVerify('2')" class="btn-min-width float-right">
                            Revisi
                        </b-button>
                        <b-button type="button" variant="primary"  @click="updateStatusVerify('1')" class="btn-min-width float-right">
                            Verifikasi
                        </b-button>
                    </template>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';
	import { getB3Status, getJenisFasilitasById, getB3StatusClass } from '@/utils/helpers';
	
	export default {
		name: 'ViewB3RTLevel1',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
					roleUser: "",
				},
				models: {

				},
			}
		},
		created() {
			const _ = this
			_.getById();
			_.getRoleUser();
		},
		methods: {
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`PemilahanPenyimpananRumahTangga/${_.$route.params.id}`);
						_.models = request.data.data;
						_.models.skala = (_.models.fasilitasTujuan && _.models.fasilitasTujuan.kecamatanId) ? 'kecamatan' : 'kota';
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
			async getRoleUser() {
				const _ = this;
				const request = await _.$axios.get(`Authentication/me`);
				if(request){
					let user = request.data.data;
					_.config.roleUser = user.userRoles.length ? user.userRoles[0].roleName : "";
				}
			},
			getB3Status(status) {
				return getB3Status(status);
			},
			getB3StatusClass(status) {
				return getB3StatusClass(status);
			},
			getJenisFasilitasById(id) {
				return getJenisFasilitasById(id);
			},
            updateStatusVerify(code) {
				const _ = this;
				_.$dialog.confirm('Anda yakin akan mengubah status verifikasi data ini?', {
					"okText": "Ya",
					"cancelText": "Tidak"
				}).then(() => {
					_.$axios.put(`PemilahanPenyimpananRumahTangga/${_.$route.params.id}/verify`, {
						id: _.models.id,
						isVerified: String(code)
					})
					.then(res => {
						_.$refs.response.setResponse(res.data.message, 'success');
						_.getById();
					})
				}).catch((error) => _.$refs.response.setResponse(error.response.data.message, 'danger'));
			},
		},
	}
</script>
